import { render } from "./QuestionnarieRange.vue?vue&type=template&id=4b740222&scoped=true"
import script from "./QuestionnarieRange.vue?vue&type=script&lang=js"
export * from "./QuestionnarieRange.vue?vue&type=script&lang=js"

import "./QuestionnarieRange.vue?vue&type=style&index=0&id=4b740222&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b740222"]])

export default __exports__